
import React, { useState, useEffect } from 'react';
import NavigationBar from './NavigationBar';
import ReadingSection from './ReadingSection';
import WritingSection from './WritingSection';
import ReadingResultsModal from './modals/ReadingResultsModal';
import FinalResultsModal from './modals/FinalResultsModal';
import useTimer from '../../hooks/useTimer';
import { useLocation } from "react-router-dom";


const TestInterface = ({
  testData,       
  currentStep,
  setCurrentStep,
  currentScenario,
  setCurrentScenario,
  currentScenarioData,
  timeRemaining,
  answers,
  setAnswers,
  readingFeedback,
  setReadingFeedback,
  writingText,
  setWritingText,
  writingAttempt,
  setWritingAttempt,
  submitted,
  setSubmitted,
  showAIFeedback,
  setShowAIFeedback,
  scenario1Results,
  setScenario1Results,
  scenario2Results,
  setScenario2Results,
  showResultsModal,
  setShowResultsModal,
  showReadingResultsModal,
  setShowReadingResultsModal,
  navigate,
  markScenarioComplete,
  isCurrentScenarioComplete,
  scenario1Completed,
  scenario2Completed,
  testId,
  allowFinalResults,
  preventAutoFinalResults,
  // ✅ Thêm prop này nhận từ test.js
  setReadingQuestions,
  // selectedScenario,
  attemptId,
  setAttemptId,
  formatTime

}) => {

  const location = useLocation();
  const viewMode = location.state?.viewMode || false;
  // const testData = React.useMemo(() => {
  //   if (!currentScenarioData) return null;
  //   return {
  //     [`scenario${currentScenario}`]: currentScenarioData
  //   };
  // }, [currentScenarioData, currentScenario]);

  // ✅ Lấy dữ liệu scenario từ loadedScenarios (nếu có)
  // const selectedScenario =
  //   loadedScenarios?.find((s) => s.id === currentScenario) || null;

  // ✅ Thay toàn bộ handleEndTest cũ
  const handleEndTest = () => {
    if (viewMode) {
      console.log("👀 View mode active — FinalResultsModal will not show.");
      return; // 🚫 Không hiển thị modal trong viewMode
    }

    console.log("✅ Test completed — showing FinalResultsModal!");
    setShowResultsModal(true);
  };



  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <NavigationBar
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        currentScenario={currentScenario}
        setCurrentScenario={setCurrentScenario}
        scenario1Results={scenario1Results}
        scenario2Results={scenario2Results}
        setAnswers={setAnswers}
        setReadingFeedback={setReadingFeedback}
        setShowReadingResultsModal={setShowReadingResultsModal}
        setWritingText={setWritingText}
        setWritingAttempt={setWritingAttempt}
        setSubmitted={setSubmitted}
        setShowAIFeedback={setShowAIFeedback}
        setShowResultsModal={setShowResultsModal}
        navigate={navigate}
        // timeRemaining={viewMode ? 0 : timeRemaining}
        timeRemaining={timeRemaining}
        formatTime={formatTime}
        scenario1Completed={scenario1Completed}
        scenario2Completed={scenario2Completed}
        markScenarioComplete={markScenarioComplete}
        allowFinalResults={allowFinalResults}
        viewMode={viewMode} // ✅ thêm dòng này
        scenarios={testData.scenarios}  // ✅ thêm dòng này
      />

      <main className="flex-1 pt-14 overflow-hidden">
        <div className="h-full container mx-auto px-6">
          {/* ✅ Reading Section */}
          {currentStep === 'reading' && (
            <ReadingSection
              currentScenario={currentScenario}
              // currentScenarioData={currentScenarioData?.reading}
              currentScenarioData={currentScenarioData}
              answers={answers}
              setAnswers={setAnswers}
              setReadingFeedback={setReadingFeedback}
              setShowReadingResultsModal={setShowReadingResultsModal}
              setScenario1Results={setScenario1Results}
              setScenario2Results={setScenario2Results}
              markScenarioComplete={markScenarioComplete}
              isCurrentScenarioComplete={isCurrentScenarioComplete}
              testId={testId}
              // ✅ Truyền xuống từ đây để ReadingSection dùng được
              setReadingQuestions={setReadingQuestions}
              viewMode={viewMode}
              handleEndTest={handleEndTest}   // ✅ truyền xuống
            />
          )}

          {/* ✅ Writing Section */}
          {currentStep === 'writing' && (
            <WritingSection
              currentScenario={currentScenario}
              // currentScenarioData={currentScenarioData?.writing}
              currentScenarioData={currentScenarioData}
              writingText={writingText}
              setWritingText={setWritingText}
              writingAttempt={writingAttempt}
              setWritingAttempt={setWritingAttempt}
              submitted={submitted}
              setSubmitted={setSubmitted}
              showAIFeedback={showAIFeedback}
              setShowAIFeedback={setShowAIFeedback}
              readingFeedback={readingFeedback}
              setCurrentScenario={setCurrentScenario}
              setCurrentStep={setCurrentStep}
              setAnswers={setAnswers}
              setReadingFeedback={setReadingFeedback}
              scenario1Results={scenario1Results}
              setScenario1Results={setScenario1Results}
              scenario2Results={scenario2Results}
              setScenario2Results={setScenario2Results}
              markScenarioComplete={markScenarioComplete}
              isCurrentScenarioComplete={isCurrentScenarioComplete}
              scenario1Completed={scenario1Completed}
              scenario2Completed={scenario2Completed}
              allowFinalResults={allowFinalResults}
              preventAutoFinalResults={preventAutoFinalResults}
              testId={testId}
              handleEndTest={handleEndTest}  // ✅ Truyền xuống để Writing gọi được
              viewMode={viewMode}
            />
          )}
        </div>
      </main>

      {/* ✅ Reading Results Modal */}
      <ReadingResultsModal
        attemptId={attemptId}
        setAttemptId={setAttemptId}
        showReadingResultsModal={showReadingResultsModal}
        setShowReadingResultsModal={setShowReadingResultsModal}
        readingFeedback={readingFeedback}
        setReadingFeedback={setReadingFeedback}
        currentScenario={currentScenario}
        // testData={testData}
        currentTest={testId}
        setCurrentStep={setCurrentStep}
        setAnswers={setAnswers}
      />

      {/* ✅ Final Results Modal */}
      <FinalResultsModal
        showResultsModal={showResultsModal}
        setShowResultsModal={setShowResultsModal}
        scenario1Results={scenario1Results}
        scenario2Results={scenario2Results}
        navigate={navigate}
      />
    </div>
  );
};

export default TestInterface;
